'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Box from '@mui/material/Box';
import { FormContext } from './FormContext';
import { noop } from 'lodash';
export default function Form({ children, sx = {}, onSubmit = noop }) {
    const { useForm } = useContext(FormContext);
    const ref = useForm();
    return (_jsx(Box, { ref: ref, component: "form", onSubmit: onSubmit, sx: sx, children: children }));
}
